import { SidebarItemTemplate, SidebarItemTemplateProps } from "./template";

export type SidebarItemProps = SidebarItemTemplateProps;

export const SidebarItem = (props: SidebarItemProps): JSX.Element => {
  return <SidebarItemTemplate {...props} />;
};
